import React, { useEffect } from 'react'
import { useSelector } from 'react-redux'
import cx from 'classnames'
import { Disclosure, DisclosureButton, DisclosurePanel } from '@headlessui/react'
import { ExpandMoreSharp } from '@mui/icons-material'
import { scrollTo } from 'libraries/front-end-core/helpers/document'
import { AOL_DISPLAY_NAMES } from 'constants/aol/aol'
import selectDeviceType from 'redux/selectors/selectDeviceType'
import { AOLType } from 'types/AOL'

interface AolTilesProps {
  aol: AOLType
  focusedAol?: string
  pageId?: string
  children: React.ReactNode
  notice?: string
}

const AolTiles = ({ aol, focusedAol, pageId, children, notice }: AolTilesProps): JSX.Element => {
  const { isMobile } = useSelector(selectDeviceType)

  useEffect(() => {
    if (focusedAol !== undefined && pageId !== undefined) {
      scrollTo({ pageId: pageId as any, id: focusedAol as any, animate: true, useWindowScrollTo: isMobile })
    }
  }, [focusedAol, pageId, isMobile])

  return (
    <Disclosure as='div' id={aol} defaultOpen>
      {({ open }: { open: boolean }) => (
        <>
          <DisclosureButton
            as='h2'
            role='button'
            data-event-category='AOL Tiles'
            data-event-action={open ? 'Close' : 'Open'}
            data-event-label={AOL_DISPLAY_NAMES[aol]}
            className={cx(
              'flex cadet-blue pb4 pointer mb5 custom-disclosure-header items-center no-select'
            )}
          >
            <div className='flex items-center'>
              <span className='flex items-center mlauto transition-all'>
                <ExpandMoreSharp className={`white br2 bg-aol-${aol} ${!open ? 'rotate--90' : ''}`} />
              </span>
              <div className='flex items-center w-100'>
                <span className='black di ml4 f4 normal'>
                  {AOL_DISPLAY_NAMES[aol]} Law
                </span>
                {/* Temp notice as R&I is not available in Skimmed. Can probably remove prop when Skimmed is populated with R&I */}
                {notice !== undefined && notice !== '' && (
                  <span className='ml4 f6 grey i'>{notice}</span>
                )}
              </div>
            </div>
          </DisclosureButton>
          <DisclosurePanel>{children}</DisclosurePanel>
        </>
      )}
    </Disclosure>
  )
}

export default AolTiles
